'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DayOfWeekUtils$$anon$10(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DayOfWeekUtils$$anon$10 as $c_Lpresto_types$DayOfWeekUtils$$anon$10 };
$p = $c_Lpresto_types$DayOfWeekUtils$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DayOfWeekUtils$$anon$10;
/** @constructor */
function $h_Lpresto_types$DayOfWeekUtils$$anon$10() {
}
export { $h_Lpresto_types$DayOfWeekUtils$$anon$10 as $h_Lpresto_types$DayOfWeekUtils$$anon$10 };
$h_Lpresto_types$DayOfWeekUtils$$anon$10.prototype = $p;
$p.a1 = (function(a) {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.V);
});
var $d_Lpresto_types$DayOfWeekUtils$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DayOfWeekUtils$$anon$10, "presto.types$DayOfWeekUtils$$anon$10", ({
  Zq: 1,
  a: 1,
  k: 1
}));
export { $d_Lpresto_types$DayOfWeekUtils$$anon$10 as $d_Lpresto_types$DayOfWeekUtils$$anon$10 };
//# sourceMappingURL=presto.types$-Day-Of-Week-Utils$$anon$10.js.map
